export { attachmentVariables as attachmentHeaderVariables } from './attachmentVariables';
